import React, {useEffect, useMemo, useState} from "react";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import type {ResolvedGallery} from "../types";
import GalleryPhotos from "../components/GalleryPhotos";
import {GalleriesRepository} from "../lib/galleriesRepository";
import {TopBarWithBreadcrumbs} from "../components/TopBarWithBreadcrumbs";

import "../App.css"
import FullWindowContainerWithScrollableContent from "../components/FullWindowContainerWithScrollableContent";
import {Container} from "@mui/material";
import {GalleriesList} from "../components/GalleriesList";

export default function GalleryPage({galleriesRepository}: { galleriesRepository: GalleriesRepository }) {
    const {id = "", photo} = useParams<{ id: string; photo?: string }>();
    const navigate = useNavigate();
    const location = useLocation();
    const [gallery, setGallery] = useState<ResolvedGallery | null>(null);
    const decodedPhoto = photo ? decodeURIComponent(photo) : undefined;

    useEffect(() => {
        const g =galleriesRepository.getGallery(id === "" ? "root" : id);
        setGallery(g);
    }, [galleriesRepository, id]);

    const crumbs = useMemo(() => {
        const parts = [{label: "Home", to: "/"}, {label: "Galleries", to: "/galleries"}];

        if (id && id !== "root" && gallery) {
            console.log(id);
            const idParts = gallery.id.split(",").slice(0, -1);
            console.log(idParts);
            idParts.forEach((idPart, i) => {
                const currentParentId = idParts.slice(0, i+1).join(",");
                console.log(currentParentId);
                const parentGallery = galleriesRepository.getGallery(currentParentId);
                parts.push({label: parentGallery.title, to: `/g/${encodeURIComponent(parentGallery.id)}`});
            })

            parts.push({label: gallery.title, to: `/g/${encodeURIComponent(gallery.id)}`});
        }
        return parts;
    }, [galleriesRepository, gallery, id]);

    function onPhotoChange(photoId: string) {
        navigate(`/g/${encodeURIComponent(gallery!.id)}/p/${encodeURIComponent(photoId)}`, {replace: false});
    }

    function onOpenPhoto(photoId: string) {
        navigate(`/g/${encodeURIComponent(gallery!.id)}/p/${encodeURIComponent(photoId)}`, {
            replace: false,
            state: {from: location},
        });
    }

    return (
        <>
            {gallery && (
                <FullWindowContainerWithScrollableContent
                    topBarContent={<TopBarWithBreadcrumbs backgroundUrl={gallery.cover?.sizeUrls[0].url!}
                                                          items={crumbs}/>}>
                    {gallery.galleries.length > 0 && <Container style={{backgroundColor: "rgba(255,255,255,0.0)", paddingTop: 16}}>
                        <GalleriesList galleries={gallery.galleries}/>
                    </Container>}
                    <Container>
                        <GalleryPhotos
                            gallery={gallery}
                            currentPhotoFilename={decodedPhoto}
                            onOpenPhoto={onOpenPhoto}
                            onCloseLightbox={() => navigate(`/g/${encodeURIComponent(gallery.id)}`, {replace: false})}
                            onPhotoChange={onPhotoChange}
                        />
                    </Container>
                </FullWindowContainerWithScrollableContent>)}
        </>
    );
}
